module.exports = __webpack_public_path__ + "site/img/129.3bc608be.jpg";